import {Component} from '@angular/core';

@Component({
    selector: 'hpjc',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent {
}
